import { render, staticRenderFns } from "./DefaultSideBar.vue?vue&type=template&id=75fd214c&"
import script from "./DefaultSideBar.vue?vue&type=script&lang=js&"
export * from "./DefaultSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports